import { render } from "./NotFoundData.vue?vue&type=template&id=d5e33406&ts=true"
import script from "./NotFoundData.vue?vue&type=script&lang=ts"
export * from "./NotFoundData.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__